import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import favicon from "../images/icon.png";
import SocialConfData from "../conf/social.json";

const SEO = ({
  description,
  title,
  slug,
  url,
  image_url,
  keywords = [],
  isPost = false,
}) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          publisher
          siteUrl
        }
      }
    }
  `);

  const slugWithoutSlashes = () => (isPost ? slug.replace(/\//g, "") : slug);

  const socialCard = isPost
    ? `${site.siteMetadata.siteUrl}/${slugWithoutSlashes()}-twitter.png`
    : `${site.siteMetadata.siteUrl}/square-social-card.png`;

  const twitterCard = isPost ? "summary_large_image" : "summary";

  // SEO: Title should be between 50 and 60 chars
  const titleTemplate =
    title && title.length > 30 ? title : `%s - ${site.siteMetadata.title}`;

  return (
    <Helmet
      title={title}
      titleTemplate={titleTemplate}
      defaultTitle={site.siteMetadata.title}
      meta={[
        {
          name: "author",
          content: site.siteMetadata.author,
        },
        {
          name: "Publisher",
          content: site.siteMetadata.publisher,
        },
        {
          name: "keywords",
          content: keywords || site.siteMetadata.keywords,
        },
        {
          name: "description",
          content: description || site.siteMetadata.description,
        },
        {
          property: `og:title`,
          content: title || site.siteMetadata.title,
        },
        {
          property: "og:description",
          content: description || site.siteMetadata.description,
        },
        {
          property: "og:url",
          content: url,
        },
        // {
        //     property: 'og:url',
        //     content: slug
        //         ? `${
        //               site.siteMetadata.siteUrl
        //           }/${slugWithoutSlashes()}/`
        //         : site.siteMetadata.siteUrl,
        // },
        {
          name: "twitter:card",
          content: twitterCard,
        },
        {
          name: "twitter:site",
          content: `@${SocialConfData.ids.twitter}`,
        },
        {
          property: "og:image",
          content: image_url,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ]}
      link={[
        {
          rel: "shortcut icon",
          type: "image/png",
          href: `${favicon}`,
        },
      ]}
    />
  );
};

SEO.defaultProps = {
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};

export default SEO;
